import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";
import { track } from "@/lib/pixels";
import { normalizeApiError } from "@/lib/api";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      const u = await login(email, password);
      toast.success("Bentornato!");
      nav(u.onboarded ? "/app" : "/onboarding");
    } catch (err) {
      toast.error(normalizeApiError(err, "Login fallito"));
    } finally { setBusy(false); }
  };

  const google = () => {
    try { track("Lead", { contents: [{ content_id: "login_google_clicked", content_type: "product", content_name: "Google login clicked" }] }); } catch {}
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <div className="min-h-screen bf-gradient-hero flex items-center justify-center p-6">
      <div className="w-full max-w-md bf-card p-8">
        <Link to="/" className="flex items-center gap-2.5 mb-8">
          <div className="w-9 h-9 rounded-xl bg-gradient-to-br from-[#6366F1] to-[#8B5CF6] flex items-center justify-center shadow-[0_6px_18px_-4px_rgba(99,102,241,0.55)]">
            <span className="text-white font-bold text-[15px]">B</span>
          </div>
          <span className="font-bold text-xl tracking-tight">BookForge <span className="text-slate-500 font-medium">AI</span></span>
        </Link>
        <h1 className="text-3xl font-bold tracking-tight mb-1">Bentornato</h1>
        <p className="text-slate-400 text-sm mb-6">Continua a costruire il tuo prossimo ebook.</p>

        {/* Google — primary */}
        <button
          type="button"
          data-testid="google-login-btn"
          onClick={google}
          className="w-full flex items-center justify-center gap-2.5 py-3 rounded-lg bg-white text-[#1f1f1f] font-medium hover:bg-slate-100 transition-colors shadow-sm">
          <svg width="18" height="18" viewBox="0 0 48 48" aria-hidden="true"><path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303c-1.649 4.657-6.08 8-11.303 8-6.627 0-12-5.373-12-12s5.373-12 12-12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 12.955 4 4 12.955 4 24s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z"/><path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 15.108 18.961 12 24 12c3.059 0 5.842 1.154 7.961 3.039l5.657-5.657C34.046 6.053 29.268 4 24 4 16.318 4 9.656 8.337 6.306 14.691z"/><path fill="#4CAF50" d="M24 44c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 35.091 26.715 36 24 36c-5.202 0-9.619-3.317-11.283-7.946l-6.522 5.025C9.505 39.556 16.227 44 24 44z"/><path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303c-.792 2.237-2.231 4.166-4.087 5.571l6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z"/></svg>
          Continua con Google
        </button>

        <div className="flex items-center gap-3 my-5">
          <div className="flex-1 h-px bg-white/[0.08]"/>
          <span className="text-[11px] uppercase tracking-widest text-slate-500">oppure</span>
          <div className="flex-1 h-px bg-white/[0.08]"/>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <input data-testid="login-email" data-clarity-mask="true" type="email" required placeholder="Email" className="bf-input" value={email} onChange={(e) => setEmail(e.target.value)}/>
          <input data-testid="login-password" data-clarity-mask="true" type="password" required placeholder="Password" className="bf-input" value={password} onChange={(e) => setPassword(e.target.value)}/>
          <button data-testid="login-submit-btn" disabled={busy} className="bf-btn-gold w-full py-3 rounded-lg disabled:opacity-50">{busy ? "Accesso…" : "Accedi"}</button>
        </form>
        <p className="mt-6 text-center text-sm text-slate-400">Non hai un account? <Link data-testid="go-to-register" to="/register" className="text-[#6366F1] hover:underline">Registrati</Link></p>
      </div>
    </div>
  );
}
